/**
 * @file automatically generated from MApp.Endpoints.Models.ControllerType
 */

export enum ControllerType {
    Form = 0,
    List = 1,
    Workflow = 2
}
